var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var TableHeaderToolTip = (function (_super) {
    __extends(TableHeaderToolTip, _super);
    function TableHeaderToolTip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableHeaderToolTip.prototype.created = function () {
    };
    TableHeaderToolTip.prototype.mounted = function () {
    };
    __decorate([
        Prop({
            required: true
        })
    ], TableHeaderToolTip.prototype, "content", void 0);
    __decorate([
        Prop({
            required: true,
            default: 'top'
        })
    ], TableHeaderToolTip.prototype, "placement", void 0);
    TableHeaderToolTip = __decorate([
        Component
    ], TableHeaderToolTip);
    return TableHeaderToolTip;
}(Vue));
export default TableHeaderToolTip;
